import { ActionsEnum } from "./settings";

export const modalWindowData: Record<
  ActionsEnum,
  { title: string; subtitle: string; buttonText1: string; buttonText2: string }
> = {
  [ActionsEnum.ADD]: {
    title: "",
    subtitle: "",
    buttonText1: "",
    buttonText2: "",
  },
  [ActionsEnum.EDIT]: {
    title: "",
    subtitle: "",
    buttonText1: "",
    buttonText2: "",
  },
  [ActionsEnum.DELETE]: {
    title: "Ви впевнені, що хочете продовжити видалення?",
    subtitle: "Цю дію неможливо скасувати. Дані будуть безповоротно видалені.",
    buttonText1: "Скасувати",
    buttonText2: "Підтвердити",
  },
  [ActionsEnum.EXIT]: {
    title: "Вийти з облікового запису?",
    subtitle: "Якщо ви вийдете зараз, доведеться повторно увійти, щоб продовжити роботу.",
    buttonText1: "Скасувати",
    buttonText2: "Вийти",
  },
  [ActionsEnum.CONFIRM_KANBAN_MOVING]: {
    title: "Переміщення картки",
    subtitle: "",
    buttonText1: "Скасувати",
    buttonText2: "Підтвердити",
  },
  [ActionsEnum.RESTORE]: {
    title: "Підтвердити відновлення",
    subtitle: "Відновити вибраний елемент/-и з кошика?\nВін буде повернений до відповідного розділу та стане доступним для роботи.",
    buttonText1: "Скасувати",
    buttonText2: "Продовжити",
  },
  [ActionsEnum.ARCHIVE]: {
    title: "Архівування елементу(-ів)",
    subtitle: "Дані будуть доступні для відновлення в кошику.",
    buttonText1: "Скасувати",
    buttonText2: "Продовжити",
  }
};
